import type { Type } from "@/realize-shared/model/Event";
import PlayerStatusMessage from "../components/PlayerStatusMessage";
import type { GameNodeProps } from "../GameNodeProps";

const PlayerLeave = (
    event: GameNodeProps<Type.PLAYER_LEAVE>,
) => (
    <PlayerStatusMessage
        {...event}
        text="$PLAYER has left"
    />
);

export default PlayerLeave;
